/* eslint-disable react/prop-types */
import React from 'react'
import {
  Breadcrumbs, Link,
  makeStyles,
} from '@material-ui/core'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import { ReactComponent as HomeIcon } from '@assets/images/svg/home.svg'
import Informations from './Informations'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '2rem',
    '& h1': {
      fontSize: '1.5rem',
      color: '#fff',
      margin: '0 0 1rem',
    },
    '& p': {
      color: theme.palette.primary.contrastText,
      margin: '0 0 1rem',
    },
    '& button': {
      minWidth: 170,
    },
  },
}))

const breadcrumbs = [
  { url: '/reseller/affiliate/dashboard', label: <HomeIcon /> },
  { url: '/reseller/affiliate/dashboard', label: 'Dashboard' },
]

const Head = ({ dashboard }) => {
  const classes = useStyles()
  const name = JSON.parse(localStorage.getItem('payload'))?.name || ''

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div>
          <h1>Dashboard</h1>
          <p>Selamat Datang di Squids Affiliate {name}</p>
        </div>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          {breadcrumbs.map((breadcrumb) => (
            <Link href={breadcrumb.url} key={breadcrumb}>
              {breadcrumb.label}
            </Link>
          ))}
        </Breadcrumbs>
      </div>
      <div className={classes.content}>
        <Informations dashboard={dashboard} />
      </div>

    </div>
  )
}

export default Head
